import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import NumberInput from '~/components/Inputs/NumberInput';
import { DoseData } from '~/state/atoms/dose/doseAtoms';

export const DOSE_NORMALIZATION_STEP = 1;
export const DOSE_NORMALIZATION_MIN_VALUE = 1;
export const DOSE_NORMALIZATION_MAX_VALUE = 100;

type DoseNormalizationProps = {
    dose?: DoseData;
    setNormalizationValue: (value: number) => void;
};

const DoseNormalization = ({
    dose,
    setNormalizationValue,
}: DoseNormalizationProps) => {
    const [inputValue, setInputValue] = useState<number | null>(
        dose?.normalizationValueGy ?? null
    );
    const [error, setError] = useState<string | null>(null);

    const handleInputChange = (newValue: number | null) => {
        if (newValue) {
            setInputValue(newValue);
            const validValue = Math.min(
                Math.max(newValue, DOSE_NORMALIZATION_MIN_VALUE),
                DOSE_NORMALIZATION_MAX_VALUE
            );
            if (!isNaN(newValue) && validValue) {
                setNormalizationValue(newValue);
                setError(null);
            } else {
                setError(
                    `Value must be between ${DOSE_NORMALIZATION_MIN_VALUE} and ${DOSE_NORMALIZATION_MAX_VALUE}`
                );
            }
        }
    };

    return (
        <NumberInput
            value={inputValue}
            fullWidth
            label={<FormattedMessage id="normalizationValue" />}
            error={error}
            min={DOSE_NORMALIZATION_MIN_VALUE}
            max={DOSE_NORMALIZATION_MAX_VALUE}
            step={DOSE_NORMALIZATION_STEP}
            onChange={handleInputChange}
            disabled={!dose?.generated}
            data-testid="set-dose-normalization"
        />
    );
};

export default DoseNormalization;
